import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { VibrationPowerModeBuilder } from '../../models/builders/vibration-power-mode.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { VibrationPowerMode } from '../../models/vibration-power-mode';

const vibrationPowerModeBody = (vibrationPowerMode: VibrationPowerMode) => ({
  name: vibrationPowerMode.name
});

@Injectable()
export class VibrationPowerModeApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }vibrationPowerModes`;
  }

  getVibrationPowerModes() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(VibrationPowerModeBuilder.fromList)
      );
  }

  getVibrationPowerMode(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(VibrationPowerModeBuilder.fromJson)
      );
  }

  createVibrationPowerMode(vibrationPowerMode) {
    return this.httpClient.post(this.apiUrl, vibrationPowerModeBody(vibrationPowerMode)).pipe(map(VibrationPowerModeBuilder.fromJson));
  }

  updateVibrationPowerMode(vibrationPowerMode: VibrationPowerMode) {
    return this.httpClient.put(`${ this.apiUrl }/${ vibrationPowerMode.hash }`, vibrationPowerModeBody(vibrationPowerMode));
  }

  deleteVibrationPowerMode(vibrationPowerMode: VibrationPowerMode) {
    return this.httpClient.delete(`${ this.apiUrl }/${ vibrationPowerMode.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/vibration-power-mode-api.service.ts